"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var FormFieldButton =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(FormFieldButton, _PureComponent);

  function FormFieldButton() {
    (0, _classCallCheck2.default)(this, FormFieldButton);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FormFieldButton).apply(this, arguments));
  }

  (0, _createClass2.default)(FormFieldButton, [{
    key: "render",
    value: function render() {
      var _this = this;

      return _react.default.createElement(_UIButton.default, {
        use: "tertiary-light",
        onClick: function onClick() {
          return _this.props.onClick(name);
        },
        style: this.props.style
      }, _react.default.createElement(_UIIcon.default, {
        name: this.props.icon
      }));
    }
  }]);
  return FormFieldButton;
}(_react.PureComponent);

exports.default = FormFieldButton;
module.exports = exports.default;